import {useMutation} from '@tanstack/react-query';
import {useTranslation} from 'react-i18next';

import {Toaster} from '@/initializers/toaster';
import {updateProfile} from '@/repositories/beneva-api/endpoints/users';
import {captureGroupedMessage} from '@/utils/sentry-helpers';

export const useUpdateUserProfile = () => {
  const {t} = useTranslation();

  return useMutation({
    mutationFn: updateProfile,
    onError: (error: Error) => {
      captureGroupedMessage('Error updating user profile', {
        level: 'error',
        fingerprint: ['user-profile-update-error'],
        tags: {
          component: 'useUpdateUserProfile',
          action: 'updateProfile',
        },
        extra: {
          error_message: error.message,
          error_name: error.name,
        },
      });

      Toaster.error(t('constants.feedback-message.default.error'));
    },
  });
};
